import { useState, useEffect } from "react";
import iconChat from "../../assets/images/icons/icon-chat.svg";
import { Field, Form, Formik, ErrorMessage } from "formik";
import { queryValidation } from "./validate";
import PrimaryButton from "../primaryButton";
import { toast } from "react-toastify";
import { useHistory, useLocation } from "react-router-dom";

import axios from "axios";
// import CustomModal from "../Modal";

function QueryForm() {
  const history = useHistory();
  const location = useLocation();
  console.log(
    "🚀 ~ file: queryForm.js ~ line 15 ~ QueryForm ~ location",
    location
  );

  const [loader, setLoader] = useState(false);
  // const [modalIsOpen, setIsOpen] = useState(false);

  // useEffect(() => {
  //   if (location.hash === "#thank-you") {
  //     setIsOpen(true);
  //   }
  // }, [location]);

  const submitForm = (data) => {
    setLoader(true);
    axios
      .post(process.env.REACT_APP_BASE_URL + "v1/contact-us", data)
      .then((res) => {
        if (res.data.success) {
          // toast.success("Query successfully submitted...");
          setLoader(false);
          // history.push("/#thank-you");
          // setIsOpen(true);
          window.location.assign("/thank-you");
          // history.push("/thank-you");
        } else {
          toast.error("OOPS 😬, something went wrong...");
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  return (
    <>
      <div className="query-form-block">
        <div className="form-heading-box fx fx--ai-fs w-100">
          <div className="icon-box">
            <img className="icon" src={iconChat} alt="icon" />
          </div>
          <div className="form-heading secondary-text-color">
            Let's find you the right communication offering for your brand.
          </div>
        </div>
        <Formik
          initialValues={{
            name: "",
            organisationName: "",
            email: "",
            phoneNumber: "",
            query: "",
          }}
          validationSchema={queryValidation}
          onSubmit={(values, { resetForm }) => {
            const newValues = {
              ...values,
              phoneNumber: values.phoneNumber.toString(),
            };
            // console.log("VLU===>", newValues);
            submitForm(newValues);
            // resetForm();
          }}
          enableReinitialize
        >
          {({ values, handleSubmit, setFieldValue, errors }) => {
            return (
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                <div className="form-item-box">
                  <div className="row">
                    <div className="col-12 col-lg-6">
                      <div className="form-item form-group">
                        <label className="label secondary-text-color">
                          Name
                        </label>
                        <Field
                          id="nameFieldQueryForm"
                          type="text"
                          value={values.name}
                          name={"name"}
                          placeholder={"Your name"}
                          hasFeedback
                          // onPressEnter={handleSubmit}
                        />
                        <ErrorMessage
                          name="name"
                          render={(msg) => <div className="danger">{msg}</div>}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-lg-6">
                      <div className="form-item form-group">
                        <label className="label secondary-text-color">
                          Organisation Name
                        </label>
                        <Field
                          type="text"
                          value={values.organisationName}
                          name={"organisationName"}
                          placeholder={"Name of Organisation"}
                          hasFeedback
                          // onPressEnter={handleSubmit}
                        />
                        <ErrorMessage
                          name="organisationName"
                          render={(msg) => <div className="danger">{msg}</div>}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-lg-6">
                      <div className="form-item form-group">
                        <label className="label secondary-text-color">
                          Email
                        </label>
                        <Field
                          type="email"
                          value={values.email}
                          name={"email"}
                          placeholder={"Email Address"}
                          hasFeedback
                          // onPressEnter={handleSubmit}
                        />
                        <ErrorMessage
                          name="email"
                          render={(msg) => <div className="danger">{msg}</div>}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-lg-6">
                      <div className="form-item form-group">
                        <label className="label secondary-text-color">
                          Contact Number
                        </label>
                        <Field
                          type="number"
                          value={values.phoneNumber}
                          name={"phoneNumber"}
                          placeholder={"Contact details"}
                          hasFeedback
                          // onPressEnter={handleSubmit}
                        />
                        <ErrorMessage
                          name="phoneNumber"
                          render={(msg) => <div className="danger">{msg}</div>}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-lg-12">
                      <div className="form-item form-group">
                        <label className="label secondary-text-color">
                          Query
                        </label>
                        <Field
                          as="textarea"
                          rows="3"
                          value={values.query}
                          name={"query"}
                          placeholder={"Drop down your query here..."}
                          hasFeedback
                          // onPressEnter={handleSubmit}
                        />
                        <ErrorMessage
                          name="query"
                          render={(msg) => <div className="danger">{msg}</div>}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="btn-box">
                    <PrimaryButton
                      className="submit-btn"
                      onClick={handleSubmit}
                      buttonName="Submit"
                      type="submit"
                      disabled={loader}
                      loader={loader}
                    />
                  </div>
                  {/* <div className="quries-contact">If you have any queries contact us at <a href="tel:+91987654321" className="tel-no">+91987654321</a></div> */}
                  <div className="quries-contact">
                    If you have any queries contact us at{" "}
                    <a href="tel:+6531658101" className="tel-no">
                      +6531658101
                    </a>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
        {/* <CustomModal modalIsOpen={modalIsOpen} setIsOpen={setIsOpen} /> */}
      </div>
    </>
  );
}
export default QueryForm;
